// Atgriešanās uz OAuth piekrišanas lapu pēc pieteikšanās (ADR 0014): serveris sūta neautorizētu lietotāju uz /?next=/oauth/authorize?…
// Adresi glabājam sessionStorage (izdzīvo arī Google pieteikšanās pāradresāciju) līdz 30 minūtēm; atļauts tikai /oauth/authorize.

const KEY = 'balansa.next';
const MAX_AGE = 30 * 60_000;

export const isSafeNext = (n: string) => n.startsWith('/oauth/authorize?') && n.length < 8000 && !n.includes('\\');

export function rememberNext(n: string) {
  if (!isSafeNext(n)) return;
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ url: n, at: Date.now() }));
  } catch {
    /* krātuve nav pieejama — lietotājs varēs atkārtot pieslēgšanu no aģenta */
  }
}

/** Gaidošā OAuth adrese (ja ir un nav novecojusi). */
export function pendingNext(): string | null {
  try {
    const v = JSON.parse(sessionStorage.getItem(KEY) || 'null') as { url?: string; at?: number } | null;
    if (v?.url && isSafeNext(v.url) && typeof v.at === 'number' && Date.now() - v.at < MAX_AGE) return v.url;
  } catch {
    /* nav */
  }
  return null;
}

/** Paņem un notīra gaidošo adresi. */
export function takeNext(): string | null {
  const n = pendingNext();
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* nav */
  }
  return n;
}
